import { KroButton } from "features/components/buttons/kroButton";
import useAuthStore from "common/store/useAuthStore";
import React, { FC, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import Routes from "router/routes";
import { useNavigate } from "react-router-dom";
import KroBackButton from "features/components/buttons/kroBackButton";
import { KroUseCases } from "common/enums/KroUseCases.enum";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  isAuthenticated: boolean;
  toggleUseCasesMenu?: () => void;
  openMenuUseCases?: () => void;
  closeMenuUseCases?: () => void;
}

interface MenuItem {
  title: string;
  imageSource?: string;
  url: string;
  description?: string;
  onItemClick?: () => void;
}

const StartFundraisingButton = (
  <a
    href={Routes.CREATE_CAMPAIGN}
    className="mx-2 flex flex-row items-center lg:inline-flex"
  >
    <div className="inline-flex h-[40px] w-[188px] items-center justify-start space-x-2 rounded-[32px] bg-brand-dark_green py-2 pl-3 pr-2 shadow">
      <div className="text-sm flex items-center text-center font-medium text-white">
        <span className="mr-1">Start </span> <span> a Fundraiser</span>
      </div>

      <img
        src="/assets/icons/GreenArrow.svg"
        className="h-[24px] w-[24px]"
        alt="arrow-forward"
      />
    </div>
  </a>
);
const KroNavBar2: React.FC<{ className?: string }> = ({ className }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);

  const path = window.location.pathname;

  const [isUseCasesMenuOpen, setUseCasesMenuOpen] = useState<boolean>(false);
  const [isMobileMenu, setMobileMenuOpen] = useState<boolean>(false);
  const [isMobileUseCasesOpen, setMobileUseCasesOpen] =
    useState<boolean>(false);

  const toggleUseCasesMenu = () => {
    setUseCasesMenuOpen(!isUseCasesMenuOpen);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenu);
  };

  const isAuthPage = path === Routes.LOGIN || path === Routes.SIGNUP;

  // const AUTHENTICATED_MENU: = [
  //   // {
  //   //   title: "Campaigns",
  //   //   url: Routes.DISCOVER_CAMPAIGN,
  //   // },
  // ];

  const UNAUTHENTICATED_MENU = [
    // {
    //   title: "Campaigns",
    //   url: Routes.DISCOVER_CAMPAIGN
    // },
    {
      title: "About",
      url: Routes.ABOUT,
    },
    {
      title: "How to use",
      url: Routes.HOW_TO_USE,
    },
    {
      title: "Contact",
      url: Routes.CONTACT_US,
    },
    {
      title: "Use Cases",
      url: Routes.USECASES(KroUseCases.CHARITY),
    },
    {
      title: "Blog",
      url: Routes.BLOG,
    },
  ];

  const getMenu = () => {
    return isAuthenticated ? [] : UNAUTHENTICATED_MENU;
  };

  const [isProfileMenuOpen, setProfileMenuOpen] = useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout>();
  const profileButtonRef = useRef<HTMLButtonElement>(null);
  const [isMenuHovered, setIsMenuHovered] = useState(false);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setProfileMenuOpen(true);
  };

  const handleMouseLeave = () => {
    if (!isMenuHovered) {
      timeoutRef.current = setTimeout(() => {
        setProfileMenuOpen(false);
      }, 150);
    }
  };

  const openUseCasesMenu = () => {
    clearTimeout(timeoutRef.current);
    setUseCasesMenuOpen(true);
  };

  const closeUseCasesMenu = () => {
    timeoutRef.current = setTimeout(() => {
      setUseCasesMenuOpen(false);
    }, 5);
  };

  if (isAuthPage) {
    return (
      <nav
        className={`mx-auto mt-2 flex h-[62px] w-full max-w-[1050px] justify-center lg:justify-start ${className}`}
      >
        <img
          src="/assets/images/givBeta.svg"
          alt="Giv"
          className="h-[45px] transform cursor-pointer transition-transform duration-300 ease-in-out hover:scale-110 md:h-[50px]"
          onClick={() =>
            isAuthenticated
              ? (window.location.href = Routes.MY_CAMPAIGNS)
              : (window.location.href = Routes.HOME)
          }
        />
      </nav>
    );
  }

  return (
    <>
      <ProfileMenu
        isOpen={isProfileMenuOpen}
        isAuthenticated={isAuthenticated}
        onClose={() => setProfileMenuOpen(false)}
        buttonRef={profileButtonRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => {
          setIsMenuHovered(false);
          handleMouseLeave();
        }}
      />
      <MobileMenu
        isOpen={isMobileMenu}
        toggleUseCasesMenu={() => setMobileUseCasesOpen(true)}
        isAuthenticated={isAuthenticated}
        onClose={() => setMobileMenuOpen(false)}
      />
      <MobileUseCasesMenu
        isOpen={isMobileUseCasesOpen}
        onClose={() => setMobileUseCasesOpen(false)}
      />
      <UseCasesMenu
        isOpen={isUseCasesMenuOpen}
        onClose={toggleUseCasesMenu}
        openMenuUseCases={openUseCasesMenu}
        closeMenuUseCases={closeUseCasesMenu}
        isAuthenticated
      />
      <nav
        className={`mx-auto mt-[27px] flex w-full items-start ${isAuthenticated ? "lg:max-w-[550px]" : "lg:max-w-[1000.5px]"} lg:items-center lg:rounded-[99px] lg:border lg:border-solid lg:border-[#E5E5E5] ${isAuthenticated ? "pl-3 pr-1" : "pl-3"} py-[5px] ${className}`}
      >
        <img
          src="/assets/images/givBeta.svg"
          alt="Giv"
          className="h-[45px] transform py-1 transition-transform duration-300 ease-in-out hover:scale-110 md:h-[50px]"
          onClick={() =>
            isAuthenticated
              ? (window.location.href = Routes.MY_CAMPAIGNS)
              : (window.location.href = Routes.HOME)
          }
        />
        <div className="ml-4 hidden items-center lg:flex lg:space-x-8">
          {getMenu().map((item, index) => (
            <a
              onMouseEnter={
                item.title === "Use Cases" ? toggleUseCasesMenu : undefined
              }
              href={item.url}
              key={index}
              className="flex items-center whitespace-nowrap px-2 text-body-lg font-normal leading-[18.2px] tracking-[-0.07px] text-[#0d111b] underline-offset-2 hover:text-[#022928] hover:underline"
            >
              {item.title}
              {item.title === "Use Cases" && (
                <img
                  src={
                    isUseCasesMenuOpen
                      ? "/assets/icons/Arrow-Up.svg"
                      : "/assets/icons/Arrow-Down.svg"
                  }
                  alt="arrow down"
                  className="ml-1 h-4 w-4"
                />
              )}
            </a>
          ))}
        </div>
        <div className="flex flex-1 items-center justify-end">
          {!isAuthenticated && (
            <a
              href={Routes.LOGIN}
              className="hidden text-[17.6px] font-medium leading-[22.88px] tracking-[-0.09] text-[#0E121B] underline-offset-2 hover:text-[#022928] lg:flex"
            >
              Sign In
            </a>
          )}
          {StartFundraisingButton}

          <button className="flex lg:hidden" onClick={toggleMobileMenu}>
            <div
              className={`flex h-[40px] w-[40px] items-center justify-center rounded-full ${!isMobileMenu ? "bg-[#4FBA6D]" : "bg-[#131313]"} mr-2`}
            >
              <img
                src={
                  isUseCasesMenuOpen
                    ? "/assets/icons/CloseWhite.svg"
                    : "/assets/icons/Menu.svg"
                }
                alt="menu"
                className="transform transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </button>
          {isAuthenticated && (
            <button
              ref={profileButtonRef}
              onClick={() => setProfileMenuOpen(!isProfileMenuOpen)} // Toggle on click
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="ml-[16px] hidden flex-row lg:flex"
            >
              <div className="flex h-[36px] w-[36px] items-center justify-center overflow-hidden rounded-[22.5px] bg-gray-300">
                {user?.profilePicture ? (
                  <img
                    src={user.profilePicture}
                    alt="Profile"
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <p>
                    {user?.organisationName !== undefined
                      ? user?.organisationName
                          ?.split(" ")[0]
                          ?.at(0)
                          ?.toUpperCase() +
                        "" +
                        user?.organisationName
                          ?.split(" ")[1]
                          ?.at(0)
                          ?.toUpperCase()
                      : user?.firstName.at(0) + "" + user?.lastName.at(0)}
                  </p>
                )}
              </div>
              <div className="flex h-[36px] items-center">
                <img src="/assets/icons/Arrow-Down.svg" alt="arrow-down" />
              </div>
            </button>
          )}
        </div>
      </nav>
    </>
  );
};

const ProfileMenu = ({
  isOpen,
  isAuthenticated,
  onClose,
  buttonRef,
  onMouseEnter,
  onMouseLeave,
}: {
  isOpen: boolean;
  isAuthenticated: boolean;
  onClose: () => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}) => {
  const [isVisible, setIsVisible] = useState(isOpen);
  const navigate = useNavigate();
  const [position, setPosition] = useState({ top: 0, right: 0 });

  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    const updatePosition = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setPosition({
          top: rect.bottom + 8,
          right: window.innerWidth - rect.right,
        });
      }
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        const menu = document.querySelector(".profile-menu-container");
        if (menu && !menu.contains(event.target as Node)) {
          onClose();
        }
      }
    };

    if (isOpen) {
      setIsVisible(true);
      updatePosition();
      window.addEventListener("resize", updatePosition);
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", updatePosition);
      setTimeout(() => setIsVisible(false), 300);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", updatePosition);
    };
  }, [isOpen, buttonRef, onClose]);

  if (!isVisible) return null;

  const PROFILE_ITEMS = [
    {
      title: "Profile",
      url: Routes.PROFILE(user?.slug ?? ""),
    },
    {
      title: "Settings",
      imageSource: "/assets/icons/settings-line.svg",
      url: Routes.SETTINGS,
    },
    {
      title: "Log Out",
      imageSource: "/assets/icons/logout-box-line.svg",
      url: Routes.LOGOUT,
    },
  ];

  const menuHeight = `${PROFILE_ITEMS.length * 85}px`;

  return ReactDOM.createPortal(
    <div
      className="profile-menu-container fixed -top-[10px] z-50 w-[151px]"
      style={{
        top: `${position.top}px`,
        right: `${position.right}px`,
        display: isVisible ? "block" : "none",
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className={`relative top-[10px] overflow-hidden rounded-[15.5px] border border-[#F1F1F1] bg-white ${isOpen ? "animate-fade-in" : "animate-fade-out"}`}
        style={{
          maxHeight: menuHeight,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col items-center justify-center space-y-[16px] p-[16px]">
          {" "}
          {PROFILE_ITEMS.map((item, index) => (
            <button
              onClick={() => {
                onClose();
                navigate(item.url);
              }}
              key={index}
              className="flex w-full flex-row items-center gap-[16px]"
            >
              {item.title === "Profile" ? (
                <div className="flex h-[24px] w-[24px] items-center justify-center overflow-hidden rounded-full bg-gray-300">
                  {user?.profilePicture != null ? (
                    <img
                      src={user.profilePicture}
                      alt="Profile"
                      className="h-[24px] w-[24px]"
                    />
                  ) : (
                    <p className="text-[10px] font-medium text-[#0E121B]">
                      {user?.organisationName !== undefined
                        ? user?.organisationName
                            ?.split(" ")[0]
                            ?.at(0)
                            ?.toUpperCase() +
                          "" +
                          user?.organisationName
                            ?.split(" ")[1]
                            ?.at(0)
                            ?.toUpperCase()
                        : user?.firstName.at(0) + "" + user?.lastName.at(0)}
                    </p>
                  )}
                </div>
              ) : (
                <img
                  src={item.imageSource}
                  alt={item.title}
                  className="h-[24px] w-[24px]"
                />
              )}
              <p className="flex-1 text-start font-dm-sans text-[14px] font-normal leading-[18.23px] text-[#131313]">
                {item.title}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
};

const MobileMenu: FC<MobileMenuProps> = ({
  isOpen,
  onClose,
  isAuthenticated,
  toggleUseCasesMenu,
}) => {
  const user = useAuthStore((state) => state.user);
  const AUTHENTICATED_MENU = [
    // {
    //   title: "Campaigns",
    //   url: Routes.DISCOVER_CAMPAIGN,
    //   description: "Discover campaigns to donate to."
    // },
    {
      title: "Profile",
      url: Routes.PROFILE(user?.slug ?? ""),
      description:
        "View and edit your personal profile, including bio, avatar, and account details.",
    },
    {
      title: "Settings",
      url: Routes.SETTINGS,
      description:
        "Manage your account preferences, privacy settings, and notification preferences.",
    },
  ];

  const UNAUTHENTICATED_MENU = [
    // {
    //   title: "Campaigns",
    //   url: Routes.DISCOVER_CAMPAIGN,
    //   description: "Discover campaigns to donate to."
    // },
    {
      title: "About",
      url: Routes.ABOUT,
      description: "Discover campaigns to donate to.",
    },
    {
      title: "How to use",
      url: Routes.HOW_TO_USE,
      description: "Discover campaigns to donate to.",
    },
    {
      title: "Contact",
      url: Routes.CONTACT_US,
    },
    {
      title: "Blog",
      url: Routes.BLOG,
      description: "Immerse yourself in our journey, one blog post at a time.",
    },
    {
      title: "Use Cases",
      url: Routes.USECASES(KroUseCases.CHARITY),
      description: "Discover campaigns to donate to.",
    },
  ];

  const getMenu = () => {
    return isAuthenticated ? AUTHENTICATED_MENU : UNAUTHENTICATED_MENU;
  };

  const [isVisible, setIsVisible] = useState(isOpen);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.classList.add("mobile-menu-open");
    } else {
      document.body.classList.remove("mobile-menu-open");
      setTimeout(() => setIsVisible(false), 300);
    }

    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [isOpen]);

  if (!isVisible) return null;

  const handleOutsideClick = () => {
    onClose();
  };

  // const menuHeight = `${getMenu().length * 85}px`;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-50 overflow-hidden bg-white"
      onClick={handleOutsideClick}
    >
      <div
        className={`p-6 pt-20 ${isOpen ? "animate-fade-in" : "animate-fade-out"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute right-2 top-2">
          <button onClick={onClose} className="p-2">
            <img src="/assets/icons/close-black.svg" alt="Close" className="" />
          </button>
        </div>
        <div className="flex flex-col gap-[24px]">
          {getMenu().map((item, index) => (
            <div
              className="flex flex-row"
              onClick={
                item.title === "Use Cases"
                  ? () => {
                      onClose();
                      if (toggleUseCasesMenu) {
                        toggleUseCasesMenu();
                      }
                    }
                  : () => {
                      onClose();
                      navigate(item.url);
                    }
              }
            >
              <div className="flex-1">
                <p className="font-dm-sans text-[16px] font-medium leading-[16px] tracking-[-0.03em] text-[#131313]">
                  {item.title}
                </p>
                <div className="flex flex-row">
                  <p className="mt-[4px] font-dm-sans text-[14px] font-normal leading-[19.6px] text-[#0E121B]">
                    {item.description}
                  </p>
                </div>
              </div>
              <div className="flex-3 flex items-center">
                {item.title === "Use Cases" && (
                  <img
                    src="/assets/icons/arrow-right.svg"
                    alt="arrow right"
                    onMouseOver={toggleUseCasesMenu}
                    className="ml-[44px] h-4 w-4"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        <KroButton
          title="Start a Fundraiser"
          className="mt-[64px] w-full"
          onclick={() => navigate(Routes.CREATE_CAMPAIGN)}
        />
        {!isAuthenticated ? (
          <p
            className="mt-[25px] text-center font-inter text-[16px] font-medium leading-[16px]"
            onClick={() => navigate(Routes.LOGIN)}
          >
            Sign In
          </p>
        ) : (
          <p
            className="mt-[25px] text-center font-inter text-[16px] font-medium leading-[16px]"
            onClick={() => navigate(Routes.LOGOUT)}
          >
            Logout
          </p>
        )}
      </div>
    </div>,
    document.body,
  );
};

const UseCasesMenu: FC<MobileMenuProps> = ({
  isOpen,
  onClose,
  openMenuUseCases,
  closeMenuUseCases,
}) => {
  const MOBILE_MENU_ITEMS: MenuItem[] = [
    {
      title: "For Charity",
      url: Routes.USECASES(KroUseCases.CHARITY),
      description: "Raise money to support the causes you care about.",
      imageSource: "/assets/icons/charity.svg",
    },
    {
      title: "Financial Emergencies",
      url: Routes.USECASES(KroUseCases.FINANCIAL_EMERGENCIES),
      description: "Get help fast when unexpected expenses hit.",
      imageSource: "/assets/icons/financial-emergencies.svg",
    },
    {
      title: "For Club & Association",
      url: Routes.USECASES(KroUseCases.CLUB_AND_ASSOCIATIONS),
      description: "Fund your club’s events and goals with ease.",
      imageSource: "/assets/icons/club-and-association.svg",
    },
    {
      title: "For Religious Projects & Causes",
      url: Routes.USECASES(KroUseCases.RELIGIOUS),
      description:
        "Bring your faith-based projects to life with community support.",
      imageSource: "/assets/icons/religious-projects.svg",
    },
    {
      title: "For Medical Bills",
      url: Routes.USECASES(KroUseCases.MEDICAL),
      description: "Get the support you need to cover medical expenses.",
      imageSource: "/assets/icons/medical-bills.svg",
    },
    {
      title: "For Projects",
      url: Routes.USECASES(KroUseCases.PROJECTS),
      description: "Fund your passion and turn your ideas into reality.",
      imageSource: "/assets/icons/projects.svg",
    },
  ];
  const [isVisible, setIsVisible] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.classList.add("mobile-menu-open");
    } else {
      document.body.classList.remove("mobile-menu-open");
      setTimeout(() => setIsVisible(false), 300);
    }

    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [isOpen]);

  if (!isVisible) return null;

  const handleOutsideClick = () => {
    onClose();
  };

  const menuHeight = `${MOBILE_MENU_ITEMS.length * 85}px`;

  return ReactDOM.createPortal(
    <div
      onMouseEnter={openMenuUseCases}
      onMouseLeave={closeMenuUseCases}
      className="fixed inset-0 top-[5px] flex h-full max-h-[544px] w-full max-w-[485px] justify-start bg-opacity-60 lg:left-[720px]"
      onClick={handleOutsideClick}
    >
      <div
        className={`relative z-10 w-full overflow-hidden rounded-[15.5px] border border-[#F1F1F1] bg-white ${
          isOpen ? "animate-slide-in" : "animate-slide-out"
        }`}
        style={{
          maxHeight: menuHeight,
          marginTop: "90px",
          marginRight: "14px",
          marginLeft: "14px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* <div className="absolute right-2 top-2">
          <button onClick={onClose} className="p-2">
            <img
              src="/assets/icons/CloseWhite.svg"
              alt="Close"
              className="h-6 w-6"
            />
          </button>
        </div> */}
        <div className="flex flex-col items-start">
          {MOBILE_MENU_ITEMS.map((item, index) => (
            <MenuItemCard
              key={index}
              title={item.title}
              imageSource={item.imageSource}
              url={item.url}
              description={item.description}
              onItemClick={onClose}
            />
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
};

const MenuItemCard = ({
  title,
  imageSource,
  url,
  description,
  onItemClick,
}: MenuItem) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onItemClick) {
      onItemClick();
    }
    navigate(url);
  };

  return (
    <button
      onClick={handleClick}
      className="duration-20 m-[14px] mx-auto mb-[4px] flex flex-row items-start px-[6px] py-[6px] transition-colors hover:py-[6px] lg:w-[443px] lg:hover:w-[443px] lg:hover:rounded-[6px] lg:hover:bg-gray-100 lg:hover:px-[6px]"
    >
      <img src={imageSource} alt={title} />
      <div className="ml-[24px] flex-col">
        <p className="text-start font-dm-sans text-[16px] font-semibold leading-[16px] tracking-[-0.3%] text-[#131313]">
          {title}
        </p>
        <p className="mt-[5px] text-start font-dm-sans text-[12px] font-normal leading-[16.8px] text-[#0E121B] lg:text-[14px] lg:leading-[19.6px]">
          {description}
        </p>
      </div>
    </button>
  );
};

const MobileUseCasesMenu = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const MOBILE_USECASES_MENU_ITEMS: MenuItem[] = [
    {
      title: "For Charity",
      url: Routes.USECASES(KroUseCases.CHARITY),
      description: "Raise money to support the causes you care about.",
      imageSource: "/assets/icons/charity.svg",
    },
    {
      title: "Financial Emergencies",
      url: Routes.USECASES(KroUseCases.FINANCIAL_EMERGENCIES),
      description: "Get help fast when unexpected expenses hit.",
      imageSource: "/assets/icons/financial-emergencies.svg",
    },
    {
      title: "For Club & Association",
      url: Routes.USECASES(KroUseCases.CLUB_AND_ASSOCIATIONS),
      description: "Fund your club’s events and goals with ease.",
      imageSource: "/assets/icons/club-and-association.svg",
    },
    {
      title: "For Religious Projects & Causes",
      url: Routes.USECASES(KroUseCases.RELIGIOUS),
      description:
        "Bring your faith-based projects to life with community support.",
      imageSource: "/assets/icons/religious-projects.svg",
    },
    {
      title: "For Medical Bills",
      url: Routes.USECASES(KroUseCases.MEDICAL),
      description: "Get the support you need to cover medical expenses.",
      imageSource: "/assets/icons/medical-bills.svg",
    },
    {
      title: "For Projects",
      url: Routes.USECASES(KroUseCases.PROJECTS),
      description: "Fund your passion and turn your ideas into reality.",
      imageSource: "/assets/icons/projects.svg",
    },
  ];

  const [isVisible, setIsVisible] = useState(isOpen);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.classList.add("mobile-menu-open");
    } else {
      document.body.classList.remove("mobile-menu-open");
      setTimeout(() => setIsVisible(false), 300);
    }

    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [isOpen]);

  if (!isVisible) return null;

  const handleOutsideClick = () => {
    onClose();
  };

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-50 overflow-hidden bg-white"
      onClick={handleOutsideClick}
    >
      <div
        className={`p-6 ${isOpen ? "animate-fade-in" : "animate-fade-out"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-row">
          <div className="flex-1">
            <KroBackButton onclick={onClose} title="Use Cases" classname="" />
          </div>
          <button onClick={onClose} className="">
            <img src="/assets/icons/close-black.svg" alt="Close" className="" />
          </button>
        </div>
        <div className="mt-[43px] flex flex-col items-start gap-[24px]">
          {MOBILE_USECASES_MENU_ITEMS.map((item, index) => (
            <div
              className="m-[14px] flex flex-row transition-colors duration-200"
              onClick={() => {
                onClose();
                navigate(item.url);
              }}
            >
              <img src={item.imageSource} alt={item.title} />
              <div className="ml-[24px] flex-col">
                <p className="text-start font-dm-sans text-[16px] font-semibold leading-[16px] tracking-[-0.3%] text-[#131313]">
                  {item.title}
                </p>
                <p className="mt-[5px] font-dm-sans text-[12px] font-normal leading-[16.8px] text-[#0E121B] lg:text-[14px] lg:leading-[19.6px]">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export { KroNavBar2 };
